import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const FilmShooting = () => {


   const location = useLocation();
  // console.log('sinnamuthu',location.pathname);
  return (
    <section className="sp-cnt-blk">
      <Container>
        <div className='sp-cnt-in text-center'>
          <div className='sp-cnt-in2 no-package'>
          <div className='hdg'><figure><Image src={`${process.env.PUBLIC_URL}/images/film-shooting-hdg.png`} fluid /></figure></div>
          <Row className='mb20 justify-content-center align-items-center'>
            <Col lg={4} sm={5}>
              <div className='item-bx'>
                <figure><Image src={`${process.env.PUBLIC_URL}/images/film-shooting-img.png`} fluid /></figure>
              </div>
            </Col>
            <Col lg={4} sm={5}>
              <div className='item-bx'>
                <figure><Image src={`${process.env.PUBLIC_URL}/images/film-shooting-img2.png`} fluid /></figure>
              </div>
            </Col>
          </Row>   
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>
                <div className='btn-whatsapp'><a href='https://wa.me/8056006677' target='_blank'><Image src="../images/ic-whatsapp.png" /> 8056006677</a></div>
              </div>
              <div className='whatsapp-blk'>
                <p>For detailed updates</p>
                <div className='btn-whatsapp'><a href='tel:4471654321' target='_blank'><Image src="../images/ic-toll-free.png" /> 4471 654321</a></div>
              </div>  
            </div>
          </Row>
          </div>
        </div>
        <div className="disclaimer">
          <div className="disclaimer-in">
            <p className="bld">Disclaimer</p>
            <p>
              The Royal Chitran Reserves the Right to Change the Price & The
              Menu without Prior Notice.
              <br />
              Saachi Choukhat Reserves the Right to Change Package & Cultural
              Activities without Prior Notice.
            </p>
          </div>
        </div>
      </Container>
    </section>      
  )
}

export default FilmShooting